'use strict';

//TODO определиться или выпилить href, или впилить везде e.preventDefault. Макар

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactBootstrap = require('react-bootstrap');

var _constants = require('redux/constants');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AuthHeader: {
        displayName: 'AuthHeader'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Auth/default/AuthHeaderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AuthHeader = _wrapComponent('AuthHeader')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(AuthHeader, _Component);

    function AuthHeader() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AuthHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthHeader.__proto__ || (0, _getPrototypeOf2.default)(AuthHeader)).call.apply(_ref, [this].concat(args))), _this), _this.show = function (e) {
            e.preventDefault();
            _this.props.show(_this.props.lang);
        }, _this.logout = function (e) {
            e.preventDefault();
            _this.props.logout();
            _this.handleClick();
        }, _this.handleClick = function () {
            _this.props.closeSideMenu();
            document.documentElement.classList.remove('scroll_hide');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AuthHeader, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                user = _props.user,
                lang = _props.lang;


            if (!!user) {
                var name = user.name || user.phone || user.email || '';

                return _react3.default.createElement(
                    'div',
                    { className: 'auth_holder' },
                    _react3.default.createElement(
                        _reactBootstrap.DropdownButton,
                        { bsStyle: 'link', title: name, noCaret: true, id: 'dropdown-basic' },
                        _constants.UserMenuItems.map(function (item, i) {
                            var notification = null;
                            var item_name = lang[item.lang_mark] ? lang[item.lang_mark] : item.name;

                            if (item.showNotification) {
                                notification = _react3.default.createElement(_components2.Notification, { isLink: false, className: 'holder_login_icon dropmenu_notification' });
                            }

                            if (item.link) {
                                return _react3.default.createElement(
                                    _reactRouterBootstrap.LinkContainer,
                                    { key: 'LinkContainer-' + i, to: item.link, onClick: _this2.handleClick },
                                    _react3.default.createElement(
                                        _reactBootstrap.MenuItem,
                                        { eventKey: i },
                                        _react3.default.createElement(
                                            'span',
                                            null,
                                            item_name
                                        ),
                                        notification
                                    )
                                );
                            } else {
                                return _react3.default.createElement(
                                    _reactBootstrap.MenuItem,
                                    { key: 'LinkContainer-' + i, eventKey: i, onClick: _this2[item.method] },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        item_name
                                    )
                                );
                            }
                        })
                    ),
                    _react3.default.createElement(_components2.Notification, {
                        className: 'holder_login_icon',
                        onClick: this.handleClick
                    })
                );
            }

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'a',
                    { href: '#', onClick: this.show },
                    _react3.default.createElement(
                        'span',
                        { className: 'auth_span' },
                        lang['login.logIn']
                    )
                )
            );
        }
    }]);
    return AuthHeader;
}(_react2.Component), _class.propTypes = {
    closeSideMenu: _react2.PropTypes.func.isRequired,
    logout: _react2.PropTypes.func.isRequired,
    setting: _react2.PropTypes.object.isRequired,
    show: _react2.PropTypes.func.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = AuthHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/default/AuthHeaderView.jsx
// module id = 1606
// module chunks = 0